module.exports = __webpack_public_path__ + "img/receipt.8b227cff.svg";